export function createEmptySelectionActionSelection() {
    return {
        line: 1,
        column: 1,
        hasSelection: false,
        selectedText: "",
    };
}

export function createSelectionActionMenuState({
    payload,
    enabled = true,
    menuWidth = 148,
    menuHeight = 44,
    margin = 8,
}) {
    if (!enabled) {
        return null;
    }

    const selection = payload?.selection;
    if (!selection?.hasSelection) {
        return null;
    }

    return {
        selection,
        position: {
            top: Math.max(margin, Math.min(window.innerHeight - menuHeight - margin, payload.top)),
            left: Math.max(margin, Math.min(window.innerWidth - menuWidth - margin, payload.left)),
        },
    };
}

export function createSelectionActionMenuItems({ onAddReview } = {}) {
    return [
        {
            id: "review-create",
            label: "리뷰 추가",
            icon: "memo",
            iconColor: "#0f8f6f",
            onSelect: onAddReview,
        },
    ].filter((item) => typeof item.onSelect === "function");
}
